import EmptyState from '@actinc/dls/components/EmptyState';
import React from 'react';
import NAMES from '~/constants/NAMES';
import AppContext from '~/context/AppContext';
import getIcon from '~/helpers/getIcon';
import LoadingPage from '../LoadingPage';
import { StyledContainer, StyledPaper, StyledTypography } from './styles';
export interface GuardDeviceIdProps {
  children: React.ReactNode;
}
export const GuardDeviceId: React.FC<GuardDeviceIdProps> = ({
  children
}: GuardDeviceIdProps): React.ReactNode | React.ReactElement<GuardDeviceIdProps> => {
  const appContext = React.useContext(AppContext);
  if (appContext.state.deviceIdIsLoading) {
    return <LoadingPage />;
  }
  if (appContext.state.deviceId) {
    return children;
  }
  return <StyledContainer data-sentry-element="StyledContainer" data-sentry-component="GuardDeviceId" data-sentry-source-file="index.tsx">
      <StyledPaper variant="outlined" data-sentry-element="StyledPaper" data-sentry-source-file="index.tsx">
        <EmptyState description={<span>
              Either your Operating System is unsupported and needs to be
              updated or you have tried to access {NAMES.ACT_GATEWAY} outside of
              the application.
              <StyledTypography>
                If you need assistance, contact {NAMES.ACT} Customer Support.
              </StyledTypography>
            </span>} Icon={getIcon('general.device')} title="No Device ID Found" data-sentry-element="EmptyState" data-sentry-source-file="index.tsx" />
      </StyledPaper>
    </StyledContainer>;
};
export default GuardDeviceId;